
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

const testimonials = [
  {
    name: 'Rohit Sharma',
    feedback: 'PDN & Associates helped streamline our compliance process and saved us countless hours. Their service is top-notch!',
    company: 'PDN & ASSOCIATES'
  },
  {
    name: 'Sneha Reddy',
    feedback: 'Professional, reliable, and extremely knowledgeable. Highly recommended for startups.',
    company: 'PDN & ASSOCIATES'
  },
  {
    name: 'Amit Verma',
    feedback: 'Their financial advice has helped our company grow tremendously. Always available when needed!',
    company: 'PDN & ASSOCIATES'
  },
  {
    name: 'Rohit Sharma',
    feedback: 'PDN & Associates helped streamline our compliance process and saved us countless hours. Their service is top-notch!',
    
  }
];

const Testimonials = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#f7f7f7',
        padding: { xs: '40px 16px', md: '60px 20px' },
      }}
    >
      <Box sx={{ textAlign: 'center', mb: { xs: '24px', md: '40px' } }}>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '28px', md: '36px' },
            fontWeight: '800',
            color: '#5DA840',
            mb: '10px',
          }}
        >
          What Our Clients Say
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              height: '2px',
              width: { xs: '40px', md: '60px' },
              backgroundColor: '#023E62',
            }}
          />
          <Box
            sx={{
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: 'white',
              border: '2px solid #023E62',
              mx: '10px',
            }}
          />
          <Box
            sx={{
              height: '2px',
              width: { xs: '40px', md: '60px' },
              backgroundColor: '#023E62',
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: { xs: '16px', md: '20px' },
          padding: { xs: '10px 16px', md: '10px 20px' },
          scrollSnapType: 'x mandatory',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {testimonials.map((item, index) => (
          <Box
            key={index}
            sx={{
              flex: { xs: '0 0 80%', sm: '0 0 300px', md: '0 0 300px' },
              background: 'white',
              borderRadius: '16px',
              padding: { xs: '16px', md: '20px' },
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              scrollSnapAlign: 'start',
            }}
          >
            <Typography
              sx={{
                fontStyle: 'italic',
                color: '#333',
                fontSize: { xs: '14px', md: '16px' },
                lineHeight: '1.6',
              }}
            >
              "{item.feedback}"
            </Typography>
            <Box sx={{ my: '15px', borderBottom: '1px solid #ccc' }} />
            <Typography
              sx={{
                fontWeight: 'bold',
                color: '#5DA840',
                fontSize: { xs: '14px', md: '16px' },
                mb: 0,
              }}
            >
              {item.name}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '12px', md: '14px' },
                color: '#777',
              }}
            >
              {/* {item.company} */}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Testimonials;